export default __webpack_public_path__ + "static/media/6-3.53a7172f.png";